import styled from "styled-components";

const RightPartContainerLink = styled.a`
  text-decoration: none !important;
  color: #222;
  background-color: transparent;
  cursor:pointer;

  &:hover {
    color: #222;
  }
`;
export default RightPartContainerLink;
